import React, { Component } from 'react';
import PropTypes from 'prop-types';

export class TreeNode extends Component {
  constructor(props) {
    super(props);

    this.state = {
      collapsed: this.props.defaultCollapsedState || true,
    };
  }

  handleCollapseEventClick = () => {
    this.setState({ collapsed: !this.state.collapsed });
  }

  render() {
    const {
      children,
      label,
    } = this.props;

    let arrowClassName = 'tree-node-arrow';
    let containerClassName = 'tree-node-children-container';
    if (this.state.collapsed) {
      arrowClassName += ' tree-node-arrow-collapsed';
      containerClassName += ' tree-node-children-collapsed';
    }

    const collapsibleLabelContainer = (
      <div>
        <div className={arrowClassName} />
        {label}
      </div>
    );

    const clickableLabelContainer = (
      <div className="marginlr20">
        {label}
      </div>
    );

    return (
      <div className="tree-node">
        <div className="tree-node-item"
          onClick={this.handleCollapseEventClick}
          role="presentation"
        >
          {children && children.length > 0 ? collapsibleLabelContainer : clickableLabelContainer}
        </div>
        <div className={containerClassName}>
        {children}
        </div>
      </div>
    );
  }
}

TreeNode.propTypes = {
  children: PropTypes.any,
  label: PropTypes.node,
  defaultCollapsedState: PropTypes.bool,
};
